module.exports = "<header class='center py1'>\n  <app-logo class='px3 py2 inline-block'></app-logo>\n</header>";


//////////////////
// WEBPACK FOOTER
// ./lib/runeset-view/header.html
// module id = 56
// module chunks = 0